var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"left",on:{"click":_vm.goback}},[_c('van-icon',{staticClass:"icon",attrs:{"name":"arrow-left"}})],1),_c('div',{staticClass:"title"},[_vm._v("课程协议")])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }